import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import ReactLoading from 'react-loading'
import { useAPI } from '../../../hooks/useAPI'
import { Patient_API } from '../PatinetAPI'
import { useHistory, useParams } from 'react-router-dom'
import { useAuth } from '../../../hooks/auth.hook'


function RegisterConfirm(props) {
  const { APIRequest } = useAPI()
  const { sms, patientId } = useParams()
  const [status, setStatus] = useState('waiting')
  const { login } = useAuth()
  const history = useHistory()

  useEffect(() => {
    sms && APIRequest(Patient_API.signIn.registerSMS(), { sms, patient_id: patientId }, { withoutToken: true }).then(res => {
      if (res.message === 'ок') {
        const token = res?.body?.data[0]
        const userId = res?.body?.data[0]?.userId

        if (token)
          login(token, userId)
        window.location.reload()

      } else
        setStatus('error')

    })
  }, [])
  return (
    <StyledRegisterConfirm className={props.className}>
      {sms && patientId && status === 'waiting'
        ?
        <>
          <ReactLoading type={'spokes'} width={200} height={200} color={'#00B1FF'} />
          <br />
          Происходит авторизация
        </>
        :
        <>
          Ошибка!
        </>

      }
    </StyledRegisterConfirm>
  )
}


const StyledRegisterConfirm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: black;
  width: 100%;
  height: 100%;
  font-size: 20px;
`

export default RegisterConfirm